import styles from "./ContentContainer.module.scss";
import ContentListTag from "./ContentListTag";
const ContentContainer = ({
  items,
  selectedTag,
  user,
  setSelectedTag,
  summary,
}) => {
  return (
    <div className={styles["content-container"]}>
      <ContentListTag
        contentList={items}
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
      />
      {items.map((item, index) => {
        if (item.label == selectedTag?.label) {
          return (
            <div className={styles["content-item"]}>
              <item.component key={index} user={user} summary={summary} />
            </div>
          );
        }
      })}
    </div>
  );
};

export default ContentContainer;
